export default __webpack_public_path__ + "static/toolsImage1-fde636abff49b51103024605f8cec915.webp";